import clsx from 'clsx';
import React from 'react';
import styles from './CardHeader.module.scss';

interface CardHeaderProps {
    children?: React.ReactNode;
    className?: string;
}

export const CardHeader: React.FC<CardHeaderProps> = ({ children, className }) => {
    return (
        <div data-slot="header" className={clsx(styles.root, className)}>
            {children}
        </div>
    );
};
